<template>
    <div class="ma-0 "> 
           

        <!-- //---------------------DIALOG -->
        <div>  
            <!-- RECORD QUOTATION -->
            <v-dialog
                v-model="dialog_record_expenses"
                scrollable   
                :persistent="false" :overlay="false"
                max-width="800px"
                transition="dialog-transition" >
                <v-card rounded="lg" v-if="dialog_record_expenses"> 
                    <v-card-title class="primary">
                        <div class="font-weight-bold b2--text">RECORD EXPENSE</div> 
                        <v-spacer></v-spacer> 
                         <v-btn @click="dialog_record_expenses=!dialog_record_expenses" icon dark><v-icon>close</v-icon></v-btn>
                    </v-card-title>
                    <v-card-text>
                        <br> 
                        <!-- <div class="mb-2">Order details  </div> -->
                        <form @submit.prevent="CREATE_NEW_EXPENSE(input,cashup)"> 
                            <mbs-input-fields class="mx-4 my-3"
                                v-model="input"
                                :outlined="true"
                                :dense="false"
                                py="1" px="1"
                                :field_items="DATA.FIELDS.expenses"
                                :select_items="DataSource"  
                                />  
                            <v-layout row wrap class="ma-0 " >
                                <v-btn @click="dialog_record_expenses = false" large  
                                    :loading="inputLoading"
                                    class="px-9 mt-3 secondary"  color="primary" height="60"  >
                                    <div class="not-f5">Cancel</div>  
                                </v-btn>   
                                <v-flex >
                                    <v-btn type="submit" large  
                                        :loading="inputLoading"
                                        class="mt-3 ml-1"  color="primary" height="60" width="100%">
                                        <div class="not-f5">Save Expense</div>  
                                    </v-btn>   
                                </v-flex> 
                                <!-- <v-flex sm4> 
                                    <v-menu v-if="MBS.actions.SIZE(ItemOrderOptionsData)>0"
                                        v-model="menu_send_and_print_option" 
                                        :close-on-content-click="false" 
                                        offset-y  offset-overflow
                                        :nudge-width="90" rounded="xl">

                                        <template v-slot:activator="{ on }">   
                                             
                                            <v-btn large  v-show="false" type="submit"
                                                :loading="inputLoading" ref="ref_btn_send_and_print"
                                                class="mt-3 "  color="secondary" height="60" width="99%">
                                                <div class="not-f5">Send & Print</div>  
                                                <v-icon class="ml-1 mr-1">arrow_drop_down</v-icon>
                                            </v-btn> 
                                            <v-btn large  v-on="on"
                                                :loading="inputLoading" 
                                                class="mt-3 "  color="secondary" height="60" width="99%">
                                                <div class="not-f5">Send & Print</div>  
                                                <v-icon class="ml-1 mr-1">arrow_drop_down</v-icon>
                                            </v-btn> 
                                        </template>  
                                        <v-card>
                                            <v-card-title primary-title class="secondary white--text">
                                                Select Print Option
                                            </v-card-title>
                                            <v-list>
                                                <v-list-item type="submit"  @click="SEND_AND_PRINT_NEW_ORDER('print_docket_and_bill')">
                                                    Send & Print Both Docket & Bill
                                                </v-list-item> 
                                                <v-list-item type="submit" @click="SEND_AND_PRINT_NEW_ORDER('print_docket')">
                                                    Send & Print Docket
                                                </v-list-item>
                                                <v-list-item type="submit" @click="SEND_AND_PRINT_NEW_ORDER('print_bill')">
                                                    Send & Print Bill
                                                </v-list-item> 
                                            </v-list>
                                        </v-card>
                                    </v-menu> 
                                </v-flex>  -->
                            </v-layout>  
                        </form>
                    </v-card-text> 
                </v-card> 
            </v-dialog> 
            
            <!-- VIEW QUOTATION -->
            <v-dialog
                v-model="dialog_view_quotations"
                scrollable   
                :persistent="false" :overlay="false"
                max-width="1100px"
                transition="dialog-transition" >
                <v-card rounded="lg" v-if="dialog_view_quotations"> 
                    <!-- <v-card-title class="primary">
                        <div class="font-weight-bold b2--text">RECORD EXPENSE</div> 
                        <v-spacer></v-spacer> 
                         <v-btn @click="dialog_view_quotations=!dialog_view_quotations" icon dark><v-icon>close</v-icon></v-btn>
                    </v-card-title>  -->
                    <mbs-item-manager
                        :filters="FILTERS" 
                        :add_vertical_lines="true"
                        :row_click="true"
                        :row_click_action="false" 
                        :fixed_header="false"
                        :height="vsh-480"
                        :min_height="300"
                        :table_title="'Issued Quotation'"
                        :table_title_icon="'mdi-clipboard-text-clock'"
                        :top_label="false"
                        :filter_date="true"
                        :filter_date_value="'local_created_at'"
                        :filter_default_days="'90'"
                        :name_items="DATA.ITEMS.QUOTATIONS.names"
                        :name_item="DATA.ITEMS.QUOTATIONS.name"
                        :value_items="DATA.ITEMS.QUOTATIONS.values"
                        :value_item="DATA.ITEMS.QUOTATIONS.value"
                        :field_items="DATA.FIELDS.QUOTATIONS"
                        :header_items="HEADER_ITEMS" 
                        :data_items="SortedBothQuotations" 
                        :is_joined="true"  
                        :path_item="PATH_ITEM"  
                        :select_items="DataSource"   

                        :table_actions="table_actions" 
                        @SELECT_TABLE_ACTION="TABLE_ACTION"
                        @SELECT_ITEM_ACTION="ITEM_ACTION"
                    />
                </v-card> 
            </v-dialog>  
          

            <!-- //print -->
            <div v-if="auto_print.printing"> 
                <mbs-auto-print 
                    @finish_print="FINISH_PRINT"
                    :show="true"  
                    :auto_print="auto_print.auto"
                    :auto_printer_name="auto_print.auto_printer_name"
                    :com_printer="auto_print.com_printer"  
                    :data="auto_print.print_data"
                    :type="auto_print.print_type"
                    :title="auto_print.print_title"
                    :printing_action="auto_print.printing_action"
                    :display_option="auto_print.display_option" 
                    />  
            </div> 
            <div v-if="dialog_doc_show"> 
                <mbs-dialog-doc-show
                    v-model="dialog_doc_show" 
                    :title="input_show_doc.title"
                    :data="input_show_doc.data"
                    :data_key="input_show_doc.data_key"
                    :document_type="input_show_doc.document_type"
                    :height="input_show_doc.height"
                    :top_header="input_show_doc.top_header"
                    :bottom_header="input_show_doc.bottom_header"
                    @on_pay_quotation="ON_PAY_QUOTATION"
                />  
            </div>
        </div>
    </div>
</template> 
<script>
let PAGE_NAME = 'CASHUP-QUOTATION'
import DATA from "../../../plugins/DATA"
import DB from "../../../plugins/DB"
import {mapState } from "vuex" 
export default { 
    props:['cashup',''],
    data(){
        return{  
            body_height:0,
             
            input:{}, 
            inputLoading:false,  
            DATA:DATA,   
            dialog_record_expenses:false,   
            dialog_view_quotations:false,   

            auto_print:{
                auto:false,
                printing:false, 
                print_data:null,
                print_type:null,
                com_printer:false, 
                print_title:null, 
                auto_printer_name:null,
                printing_action:null, 
                display_option:'',  
            },
            dialog_doc_show:false,
            input_show_doc:{
                // title:"INVOICE..",
                top_header:true
            },
            table_actions:[  
                {type:"action",btn:true,icon:"mdi-close",action:"close",color:"secondary", outlined:false,  text:"Close"},  
                {type:"action",btn:true,icon:"mdi-refresh",action:"refresh",color:"secondary", outlined:false,  text:"Refresh"},   
                {type:"action",icon:"mdi-microsoft-excel",action:"export_excel",color:"secondary", outlined:false,  text:"Export to Excel"},  
            ],
            TOTAL_ITEM_VALUES:[ 
                // {name:'Total Items',value:'total_quantity'}, 
                {name:'Total Price',value:'total_sold_price',show_value:'total_sold_price_',money:true},
            ], 
            
        } 
    }, 
    created() {
        try {
            this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);   
            this.MBS.events.$on('ON_FIND_QUOTATION', this.ON_FIND_QUOTATION);   
            this.MBS.events.$on('ON_ISSUED_QUOTATIONS', this.ON_ISSUED_QUOTATIONS);   
 
            
        } catch (error) {
            this.MBS.actions.error({
                error:error,
                from:'created',
                page:PAGE_NAME, 
            }) 
        }
    },
    mounted(){  
    },
    computed:{
        route(){
            return this.$route
        },
        vs(){

            return this.$vuetify.breakpoint
        }, 
        vsh(){
            return this.vs.height
        },  
        ...mapState({
            loading:state=>state.load.loading,
            processes:state=>state.load.processes,
            responses:state=>state.load.responses,
        }),
        ...mapState({
            us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
            ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
            SELECTED_COMPANY: state=> state.items['SELECTED_COMPANY'], 
        }),
        ...mapState({
            CompanySettings: state=> state.items[(DATA.ITEMS.COMPANY_SETTINGS.values).toUpperCase()],  
            LocalCashups: state=> state.locals[(DATA.ITEMS.LOCAL_CASHUPS.values).toUpperCase()],
            StockOutlets: state=> state.items[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()],
            JoinedStockOutlets: state=> state.join[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()], 
            Expenses: state=> state.items[(DATA.ITEMS.EXPENSES.values).toUpperCase()],
            JoinedExpenses: state=> state.join[(DATA.ITEMS.EXPENSES.values).toUpperCase()], 

            Customers: state=> state.items[(DATA.ITEMS.CUSTOMERS.values).toUpperCase()], 
            JoinedCustomers: state=> state.join[(DATA.ITEMS.CUSTOMERS.values).toUpperCase()], 
            CustomerGroups: state=> state.items[(DATA.ITEMS.CUSTOMER_GROUPS.values).toUpperCase()], 
            JoinedCustomerGroups: state=> state.join[(DATA.ITEMS.CUSTOMER_GROUPS.values).toUpperCase()], 
            Suppliers: state=> state.items[(DATA.ITEMS.SUPPLIERS.values).toUpperCase()], 
            JoinedSuppliers: state=> state.join[(DATA.ITEMS.SUPPLIERS.values).toUpperCase()], 
            SupplierCategories: state=> state.items[(DATA.ITEMS.SUPPLIER_CATEGORIES.values).toUpperCase()], 
            JoinedSupplierCategories: state=> state.join[(DATA.ITEMS.SUPPLIER_CATEGORIES.values).toUpperCase()], 

            PaymentMethods: state=> state.items[(DATA.ITEMS.PAYMENT_METHODS.values).toUpperCase()],
            JoinedPaymentMethods: state=> state.join[(DATA.ITEMS.PAYMENT_METHODS.values).toUpperCase()],
            DefaultPaymentMethod: state=> state.app[(DATA.ITEMS.DEFAULT_PAYMENT_METHODS.values).toUpperCase()],
            DefaultMoneyAccount: state=> state.app[(DATA.ITEMS.DEFAULT_MONEY_ACCOUNTS.values).toUpperCase()], 
            DefaultBillAccount: state=> state.app[(DATA.ITEMS.DEFAULT_BILL_METHODS.values).toUpperCase()], 
            DefaultExpenseCategories: state=> state.app['DEFAULT_EXPENSE_CATEGORIES'],
            DefaultExpenseAccounts: state=> state.app['DEFAULT_EXPENSE_ACCOUNTS'],    

            Quotations: state=> state.items[(DATA.ITEMS.QUOTATIONS.values).toUpperCase()],
            JoinedQuotations: state=> state.join[(DATA.ITEMS.QUOTATIONS.values).toUpperCase()], 
            LocalQuotations: state=> state.locals[(DATA.ITEMS.LOCAL_QUOTATIONS.values).toUpperCase()],
            JoinedLocalQuotations: state=> state.join[(DATA.ITEMS.LOCAL_QUOTATIONS.values).toUpperCase()], 
        }), 
        
        ExpensesData(){
            let items = this.JoinedExpenses?this.JoinedExpenses:this.Expenses 
            if(!items){return null}
            let list = [...items]
            list.sort(this.MBS.actions.dynamicSort("created_at_server",false))   
            list.sort(this.MBS.actions.dynamicSort("expense_date",false))    
            return list 
        },
        CustomersData(){
            const Customers = this.Customers
            const JoinedCustomers = this.JoinedCustomers  
            return JoinedCustomers?JoinedCustomers:Customers
        }, 
        CustomerGroupsData(){
            const CustomerGroups = this.CustomerGroups
            const JoinedCustomerGroups = this.JoinedCustomerGroups  
            return JoinedCustomerGroups?JoinedCustomerGroups:CustomerGroups
        },
        CustomerGroupsData(){
            const CustomerGroups = this.CustomerGroups
            const JoinedCustomerGroups = this.JoinedCustomerGroups  
            return JoinedCustomerGroups?JoinedCustomerGroups:CustomerGroups
        },
        StockOutletsData(){
            let items = this.JoinedStockOutlets?this.JoinedStockOutlets:this.StockOutlets  
            return items 
        },
        ExpenseAccountsData(){ 
            let items = this.JoinedExpenseAccounts?this.JoinedExpenseAccounts:this.ExpenseAccounts
            return items
        },
        SuppliersData(){
            let items = this.JoinedSuppliers?this.JoinedSuppliers:this.Suppliers
            return items
        }, 
        PaymentMethodsData(){
            let items = []
            let DefaultBillAccount = this.DefaultBillAccount  
            let DefaultPaymentMethod = this.DefaultPaymentMethod 
            let PaymentMethods= this.JoinedPaymentMethods?this.JoinedPaymentMethods:this.PaymentMethods
            if(DefaultBillAccount){
                items = [...DefaultBillAccount]
            }
            if(DefaultPaymentMethod){
                items= [
                    ...items,
                    ...DefaultPaymentMethod
                ]
            } 
            if(PaymentMethods){
                items= [
                    ...items,
                    ...PaymentMethods
                ]
            } 
            return items
        },
        AllExpenseAccounts(){
            let defaults = this.DefaultExpenseAccounts
            defaults = this.MBS.actions.JOIN_EXPENSE_ACCOUNTS(defaults)
            let accounts = this.ExpenseAccountsData
            let all = []
            if(defaults){
                defaults.forEach(category => {
                    all.push({
                        ...category,
                        default:true
                    }) 
                });
            }
            if(accounts){
                all=[
                    ...all,
                    ...accounts
                ]
            } 
            
            return all
        },
        AllExpenseCategories(){
            let defaults = this.DefaultExpenseCategories
            let categories = this.ExpenseCategoriesData
            let all = []
            if(defaults){
                defaults.forEach(category => {
                    all.push({
                        ...category,
                        default:true
                    }) 
                });
            }
            if(categories){
                all=[
                    ...all,
                    ...categories
                ]
            } 
            return all
        },
         
        DataSource(){
            let ExpenseCategories = this.AllExpenseCategories  
            let ExpenseAccounts = this.AllExpenseAccounts  
            let Suppliers = this.SuppliersData
            let PaymentMethods = this.PaymentMethodsData   
            let StockOutlets = this.StockOutletsData   

            console.log(Suppliers,'Suppliers+++++++++++++++++++');
            
            return {
                ExpenseAccounts:ExpenseAccounts,
                Suppliers:Suppliers,
                PaymentMethods:PaymentMethods,
                ExpenseCategories:ExpenseCategories,
                StockOutlets:StockOutlets,
            }
        },

        PATH_ITEM(){  
            let path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.expenses,true) 
            return path
        }, 
        FILTERS(){ 
            return [   
                {
                    type:"autocomplete",value:"payment_method_code",prepend_inner_icon:'mdi-account-cash',clearable:true,filled:false,multiple:true,
                    chips:true,deletable_chips:true,label:"Payment",
                    select:{
                        name:'PaymentMethods',
                        value:'code',
                        text:'name'
                    }, 
                    required:false,sm:12,md:6,step_name:"Name"
                },   
                {
                    type:"autocomplete",value:"expense_account_code",barcode:true,prepend_inner_icon:'mdi-cash-sync',clearable:true,filled:false,multiple:true,
                    chips:true,deletable_chips:true,label:"Account",
                    select:{
                        name:'ExpenseAccounts',
                        value:'code',
                        text:'name'
                    }, 
                    required:false,sm:12,md:6,step_name:"Name"
                },     
                {
                    type:"autocomplete",value:"supplier_code",barcode:true,prepend_inner_icon:'mdi-human-dolly',clearable:true,filled:false,multiple:true,
                    chips:true,deletable_chips:true,label:"Supplier",
                    select:{
                        name:'Suppliers',
                        value:'code',
                        text:'name'
                    }, 
                    required:false,sm:12,md:12,step_name:"Name"
                },     
            ]
        }, 
        HEADER_ITEMS(){
            return [ 
            {id:1,name:"General",title:true}, 
                {id:0,name:"",value:'icon_image',color:"primary",size:40,tile:true,show:true},
                {id:0,name:"Number",value:'no',show:false},   
                {id:0,name:"Date",value:'local_created_at_',show:true},   
                // {id:0,name:"Payment",value:"payment_method_name",show:true},     
                {id:0,name:"S. Key",value:'day_shift_key',show:false},   
                {id:0,name:"C. Key",value:'cashup_key',show:false},      
                {id:0,name:"Quotation No.",value:"receipt_number_",align:"right",show:true},         
                {id:0,name:"Outlet",value:"outlet_name",show:false},         
                {id:0,name:"Teller",value:"teller_name",show:false},         
                {id:0,name:"Till",value:"till_name",show:false},         
                {id:0,name:"Customer",value:'customer_name',show:true},   
                {id:0,name:"Account",value:'receivable_name',show:true},   
                {id:0,name:"Items",value:'total_quantity_',align:'right',show:true},    
                {id:0,name:"Price",value:'total_sold_price_',align:'right',show:true},   
                {id:0,name:"update",value:'updated_at',show:false},   
                {id:0,name:"action",align:"right",show:true,item:[ 
                    {name:"View  Quotation",action:"view_quotation",icon:"mdi-eye"}, 
                    {name:"Pay  Quotation",action:"view_quotation",icon:"mdi-cash"}, 
                    {name:"Archive Quotation",action:"archive_item",icon:"mdi-delete"},   
                ]}, 
            ]
        }, 
        LocalQuotationsData(){ 
                let us = this.us
                let uid = us?us.uid:null 
                let LocalQuotations = this.LocalQuotations
                let JoinedLocalQuotations = this.JoinedLocalQuotations
                let items = JoinedLocalQuotations?JoinedLocalQuotations:LocalQuotations 
                console.log(LocalQuotations,'LocalQuotations..........');
                console.log(JoinedLocalQuotations,'JoinedLocalQuotations..........');
                if(!items){return null}
                let mys = items.filter(sale=>{
                    return sale.created_uid == uid
                }) 
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("local_created_at",false)) 
                
                return list
            },
            QuotationsData(){
                let Quotations = this.Quotations
                let JoinedQuotations = this.JoinedQuotations
                let items = JoinedQuotations?JoinedQuotations:Quotations
                console.log(Quotations,'Quotations..........');
                console.log(JoinedQuotations,'JoinedQuotations..........');
                if(!items){return null}
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("local_created_at",false))  
                return list 
            },
             
            BothQuotations(){
                let locals = this.LocalQuotationsData
                let quotations = this.QuotationsData

                if(!quotations && !locals){return null}
                if(quotations && !locals){return quotations}
                if(!quotations && locals){return locals}

                let both = [...quotations]
                locals.forEach(element => {
                    let item = quotations.find(item=>{
                        return item.key == element.key
                    })
                    if (!item) {
                        both.push(element)
                    } 
                });
                let list = [...both]
                list.sort(this.MBS.actions.dynamicSort("local_created_at",false))  
                return list
            },
            SortedBothQuotations(){
                let items = this.BothQuotations 
                if(!items){return null}
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("key",false)) 
                console.log(list,'....................****');
                return list
            }
         
         
    },
    methods:{  
        TABLE_ACTION(action,item){
            try { 
                let route = this.route
                let fullPath = route?route.fullPath:null
                    console.log(action,'action');
                if (action == "refresh") { 
                    this.REFRESH_ORDERS()
                }else if (action == "close") { 
                    this.dialog_view_quotations = false
                }else if (action == "exit") { 
                    this.EXIT_DIALOG()
                } 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'TABLE_ACTION',
                    page:PAGE_NAME, 
                }) 
            } 
        }, 
        ITEM_ACTION(action,item){
            try { 
                let link = "/stock/stock-control/"+(item?item.key:null)
                const path = this.MBS.actions.COMPANY_LINK(link,true) 
                console.log(item,'...');
                if (action == "view_quotation") {
                    // let account_type = item?item.account_type:null
                    // let receipt_key = item?item.key:null
                    // this.MBS.actions.go("/sales-quotation/"+receipt_key) 
                    this.SHOW_DIALOG_DOCUMENT({
                        data:item,
                        doc_title:"QUOTATION",
                        doc_type:'quotation',
                    }) 
                } else if (action == "on_row_clicked") {
                    this.SHOW_DIALOG_DOCUMENT({
                        data:item,
                        doc_title:"QUOTATION",
                        doc_type:'quotation',
                    })
                }
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'TABLE_ACTION',
                    page:PAGE_NAME, 
                }) 
            }
            
        },

        ON_FIND_QUOTATION(event){
            try { 
                const cashup = this.cashup
                const outlet_code = cashup?.outlet_code
                this.dialog_record_expenses = true  
                this.input = {
                    outlet_code
                }
                console.log(this.input,'this.input.....');
                
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'ON_FIND_QUOTATION',
                    page:PAGE_NAME, 
                }) 
            } 
        }, 
        ON_ISSUED_QUOTATIONS(event){
            try { 
                this.dialog_view_quotations = true
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'ON_ISSUED_QUOTATIONS',
                    page:PAGE_NAME, 
                }) 
            } 
        }, 
        ON_PAY_QUOTATION(event){
            try { 
                // console.log(quotation,'questi,,,,,,,,,,,,,,,,,,');
                this.dialog_view_quotations = false
                this.$emit("on_pay_quotation",event)

                
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'ON_PAY_QUOTATION',
                    page:PAGE_NAME, 
                }) 
            } 
        }, 
        CREATE_NEW_EXPENSE(action,item){
            try { 
                 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'TABLE_ACTION',
                    page:PAGE_NAME, 
                }) 
            } 
        }, 

        SHOW_DIALOG_DOCUMENT(payload){
            try {
                let data = {}
                let doc_type = payload?.doc_type
                let doc_title = payload?.doc_title
                if(payload?.data){
                    data = payload?.data
                }
                if(payload?.key){
                    data.key = payload?.key
                }
                if(!this.input_show_doc){
                    this.input_show_doc = {}
                } 
                if(data=={}){return null}
                if (doc_type) {
                    console.log(doc_type,'doc_type/.................');
                }

                this.input_show_doc.data = {...data,merge_doc_type:"receipt"}
                this.input_show_doc.data_key = data.key
                this.input_show_doc.title = doc_title
                this.input_show_doc.document_type = doc_type?doc_type:"invoice"
                this.dialog_doc_show = true  
                console.log(this.input_show_doc,'this.input_show_doc.....');
                
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'SHOW_DIALOG_DOCUMENT',
                    page:PAGE_NAME, 
                }) 
            } 
        },
         
        //-------------[main]
        async DIALOG_YES(action){ 
            try {
                if (action.code) {
                    if (action.code ===PAGE_NAME+'=CONFIRM-SELECT-COMPANY') {
                        if (action.YES) {
                            setTimeout(() => { 
                                this.input.check = true 
                                this.MBS.actions.dialogInput({
                                    show:true,
                                    fixed:true,
                                    title:"CONFIRM",
                                    text:"Enter your password to confirm switching to "+this.MBS.actions.TEXT_UP(action.data.company_name)+".",
                                    btnYes:"CONFIRM",
                                    field:[
                                        {field:"password",label:'Password',type:'password'}
                                    ],
                                    action:{
                                        ...action,
                                        code:PAGE_NAME+"=SELECT-COMPANY",
                                    }
                                })  
                            }, this.MBS.data.ACTION_REFRESH_TIME); 
                        } else {
                            
                        }  
                    } 
                    if (action.code ===PAGE_NAME+'=SELECT-COMPANY') {
                        if (action.YES) {
                            setTimeout(() => { 
                                let password = action.password
                                password = password?this.MBS.crypt.encrypt(password):null 
                                if (!password) { 
                                    this.MBS.actions.dialog(null,true,false,"ERROR","Wrong password entered",null,"OK")
                                }else if (password!==this.ud.p_uid) { 
                                    this.MBS.actions.dialog(null,true,false,"ERROR","Wrong password entered",null,"OK")
                                } else {
                                    this.SELECT_COMPANY(action.data) 
                                }   
                            }, this.MBS.data.ACTION_REFRESH_TIME);    
                        } else {
                            
                        }
                    }   
                } 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'DIALOG_YES',
                    page:PAGE_NAME, 
                }) 
            }  
        },
    },
    beforeDestroy(){
        this.MBS.events.$off('DIALOG_YES', this.DIALOG_YES);       
        this.MBS.events.$off('ON_FIND_QUOTATION', this.ON_FIND_QUOTATION);       
        this.MBS.events.$off('ON_ISSUED_QUOTATIONS', this.ON_ISSUED_QUOTATIONS);       
    },
    watch:{   
        LocalCashup(value){ 
        },
         
    }
}
</script> 